import moment from 'moment';

export const formatDate = dateValue => {
  const date = moment(dateValue);
  const formattedDate = date.format('D MMM YYYY');
  const formattedTime = date.format('h:mm A');
  return `${formattedDate}, ${formattedTime}`;
};

export const prepareVendorDocsTableData = vendorDocs => {
  const availableDocs = vendorDocs.flatMap(
    docCategory => docCategory.docRequirements,
  );

  const formattedTableData = availableDocs.map(doc => {
    const { addedOn, docName, docValue, docStatus, inputType, remarks } = doc;
    const docType = inputType === 'VALUE' ? 'input' : 'doc';

    return {
      submittedOn: addedOn,
      docName,
      docVal: docValue,
      status: docStatus,
      docType,
      reason: remarks,
    };
  });
  return formattedTableData;
};
